module.exports = __webpack_public_path__ + "img/empty-speaker.f97a02f6.jpg";